import { Cloudinary } from '@cloudinary/base'

const cld = new Cloudinary({
  cloud: {
    cloudName: 'ordersmadesimple',
  },
})

export default cld
